module.exports = __webpack_public_path__ + "static/media/YM55_0.9c7d9974.jpg";